import { useId } from "react";
import type { ThemeId } from "../../theme/themes";

/** A miniature of the portal drawn with plain CSS in the given theme: the
 * preview root carries data-theme, so the tokens inside it resolve to that
 * theme regardless of the page's own theme. */
export function ThemePreview({ theme, name, description, selected, onSelect }: {
  theme: ThemeId;
  name: string;
  description: string;
  selected: boolean;
  onSelect: () => void;
}) {
  const descriptionId = useId();
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      aria-label={name}
      aria-describedby={descriptionId}
      className={"theme-card" + (selected ? " selected" : "")}
      onClick={onSelect}
    >
      <div className="theme-thumb" data-theme={theme} aria-hidden="true">
        <div className="tt-topbar"><span className="tt-brand" /><span className="tt-dot" /></div>
        <div className="tt-body">
          <div className="tt-side"><span /><span className="active" /><span /></div>
          <div className="tt-main">
            <div className="tt-row"><span className="tt-cell w1" /><span className="tt-cell w2" /><span className="tt-tag ok" /></div>
            <div className="tt-row"><span className="tt-cell w1" /><span className="tt-cell w3" /><span className="tt-tag warn" /></div>
            <div className="tt-btn" />
          </div>
        </div>
      </div>
      <div className="theme-card-text">
        <strong>{name}</strong>
        <span id={descriptionId}>{description}</span>
      </div>
    </button>
  );
}
